var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 50,
    viewBox: "0 0 38 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.81196 0H23.5286L37.6965 14.7676V43.4908C37.6965 47.089 34.7855 50 31.1997 50H6.81196C3.21377 50 0.302734 47.089 0.302734 43.4908V6.50922C0.302671 2.91103 3.21371 0 6.81196 0Z",
    fill: "#E5252A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5161 0V14.6552H37.6965L23.5161 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53662 37.3048V28.1719H11.4222C12.3842 28.1719 13.1464 28.4342 13.7211 28.9715C14.2958 29.4962 14.5831 30.2084 14.5831 31.0954C14.5831 31.9825 14.2958 32.6946 13.7211 33.2194C13.1464 33.7566 12.3842 34.019 11.4222 34.019H9.87295V37.3048H7.53662ZM9.87295 32.0325H11.1598C11.5096 32.0325 11.7845 31.9575 11.9719 31.7826C12.1593 31.6202 12.2593 31.3953 12.2593 31.0955C12.2593 30.7957 12.1594 30.5707 11.9719 30.4083C11.7846 30.2334 11.5097 30.1585 11.1598 30.1585H9.87295V32.0325ZM15.5451 37.3048V28.1719H18.781C19.4182 28.1719 20.0179 28.2593 20.5801 28.4467C21.1423 28.6341 21.6546 28.8966 22.1043 29.2589C22.5541 29.6087 22.9164 30.0834 23.1788 30.6831C23.4286 31.2829 23.5661 31.97 23.5661 32.7446C23.5661 33.5067 23.4287 34.1939 23.1788 34.7935C22.9164 35.3933 22.5541 35.868 22.1043 36.2178C21.6545 36.5801 21.1423 36.8425 20.5801 37.0299C20.0179 37.2173 19.4182 37.3048 18.781 37.3048H15.5451ZM17.8315 35.3183H18.5061C18.8684 35.3183 19.2058 35.2809 19.5181 35.1934C19.8179 35.1059 20.1053 34.9685 20.3802 34.7811C20.6426 34.5937 20.855 34.3313 21.0049 33.9815C21.1548 33.6317 21.2298 33.2194 21.2298 32.7446C21.2298 32.2573 21.1548 31.845 21.0049 31.4953C20.855 31.1455 20.6426 30.8831 20.3802 30.6956C20.1053 30.5083 19.818 30.3708 19.5181 30.2834C19.2058 30.1959 18.8684 30.1584 18.5061 30.1584H17.8315V35.3183ZM24.7405 37.3048V28.1719H31.2373V30.1584H27.0769V31.6201H30.4002V33.5942H27.0769V37.3048H24.7405Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.837ee2c7e1ba6a94274a401c415a6c67.svg";
export { ForwardRef as ReactComponent };